export function envValue(clientKey) {
    return envVariables[clientKey];
}


// WEBPACK FOOTER //
// ./config/envUtils.js